document.addEventListener('DOMContentLoaded', function() {
  var toggle = document.querySelector('.glass-toggle');
  var links  = document.querySelector('.glass-links');
  var nav    = document.querySelector('.glass-nav');
  var heroBg = document.querySelector('.arra-hero__bg');
  var isMobile = window.innerWidth <= 860;

  /* Mobile menu toggle */
  if (toggle && links) {
    toggle.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      var isOpen = links.classList.toggle('open');
      toggle.classList.toggle('active');
      toggle.setAttribute('aria-expanded', String(isOpen));
    });

    // Solo cerrar el menú al tocar enlaces que navegan (anchors + sub-enlaces).
    // El botón padre del desplegable (button.glass-link--parent) NO debe cerrar.
    var allLinks = links.querySelectorAll('a.glass-link, .glass-dropdown-link');
    for (var i = 0; i < allLinks.length; i++) {
      allLinks[i].addEventListener('click', function() {
        links.classList.remove('open');
        toggle.classList.remove('active');
        toggle.setAttribute('aria-expanded', 'false');
      });
    }

    document.addEventListener('click', function(e) {
      if (!toggle.contains(e.target) && !links.contains(e.target)) {
        links.classList.remove('open');
        toggle.classList.remove('active');
        toggle.setAttribute('aria-expanded', 'false');
      }
    });
  }

  window.addEventListener('resize', function() {
    isMobile = window.innerWidth <= 860;
  });

  /* ============================
     CART BADGE — Actualización en tiempo real
     ============================ */
  function updateCartBadge() {
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        var badges = document.querySelectorAll('.glass-action__badge');
        var cartLink = document.querySelector('.glass-action--cart');
        if (!cartLink) return;

        if (cart.item_count > 0) {
          if (badges.length) {
            for (var i = 0; i < badges.length; i++) {
              badges[i].textContent = cart.item_count;
            }
          } else {
            var badge = document.createElement('span');
            badge.className = 'glass-action__badge';
            badge.textContent = cart.item_count;
            cartLink.appendChild(badge);
          }
        } else {
          for (var j = 0; j < badges.length; j++) {
            badges[j].remove();
          }
        }
      })
      .catch(function() {});
  }

  /* Escuchar eventos nativos del tema Horizon (no monkey-patch global de fetch).
     ThemeEvents.cartUpdate = 'cart:update' es el evento que dispara
     Horizon en cart-icon.js, component-cart-items.js, etc. */
  document.addEventListener('cart:update', updateCartBadge);
  document.addEventListener('cart:change', updateCartBadge);
  /* Compatibilidad con eventos legacy que algunos apps de Shopify disparan */
  document.addEventListener('ajaxProduct:added', updateCartBadge);
  document.addEventListener('cart:added', updateCartBadge);

  /* ============================
     CART: Redirigir links al personalizador
     Mapea el "handle" del producto → URL de personalización.
     Solo los productos listados aquí se redirigen;
     los demás mantienen su link normal.
     ============================ */
  var cartLinkRedirects = {
    'anillo-galaxia': '/pages/personalizacion-anillo-galaxia',
    'charm-calado':   '/pages/personalizacion-anillo-galaxia',
    'charm-gema':     '/pages/personalizacion-anillo-galaxia',
    'charm-estampado': '/pages/personalizacion-anillo-galaxia'
    // Agrega más productos aquí:
    // 'otro-producto': '/pages/otra-pagina'
  };

  function rewriteCartLinks(scope) {
    var root = scope || document;
    var links = root.querySelectorAll('.cart-items__title, .cart-items__media-container');
    for (var i = 0; i < links.length; i++) {
      var href = links[i].getAttribute('href');
      if (!href) continue;
      // Extraer el handle: /products/anillo-galaxia?variant=123 → anillo-galaxia
      var match = href.match(/\/products\/([^?#/]+)/);
      if (match && cartLinkRedirects[match[1]]) {
        links[i].setAttribute('href', cartLinkRedirects[match[1]]);
      }
    }
  }

  // Re-ejecutar cuando el carrito se actualiza (AJAX)
  var cartObserverTarget = document.querySelector('.cart-items__wrapper');
  var cartMutObs = null;

  function stopObserving() {
    if (cartMutObs) cartMutObs.disconnect();
  }

  function startObserving() {
    if (cartMutObs && cartObserverTarget) {
      cartMutObs.observe(cartObserverTarget, { childList: true, subtree: true });
    }
  }

  if (cartObserverTarget && 'MutationObserver' in window) {
    var mutTimer = null;
    cartMutObs = new MutationObserver(function() {
      clearTimeout(mutTimer);
      mutTimer = setTimeout(function() {
        stopObserving();
        rewriteCartLinks();
        groupBundleItems();
      }, 400);
    });
    startObserving();
  }

  /* ============================
     CART: Cache de items (para el undo toast)
     ============================ */
  var _arraCartCache = [];

  /* ============================
     CART: Toast "Deshacer" al eliminar
     ============================ */
  var _arraPendingUndo = null;
  var _undoSetupWrapper = null;

  function getOrCreateUndoToast() {
    var el = document.getElementById('arra-undo-toast');
    if (el) return el;
    el = document.createElement('div');
    el.id = 'arra-undo-toast';
    el.className = 'arra-undo-toast';
    el.setAttribute('role', 'status');
    el.setAttribute('aria-live', 'polite');
    el.innerHTML =
      '<span class="arra-undo-toast__msg"></span>' +
      '<button type="button" class="arra-undo-toast__btn">Deshacer</button>' +
      '<div class="arra-undo-toast__bar"><div class="arra-undo-toast__progress"></div></div>';
    document.body.appendChild(el);
    return el;
  }

  function showUndoToast(label, items, card) {
    // Si hay uno pendiente, ejecutar el anterior de inmediato
    if (_arraPendingUndo) {
      clearTimeout(_arraPendingUndo.timer);
      _arraPendingUndo.commit();
    }

    var toast = getOrCreateUndoToast();
    toast.querySelector('.arra-undo-toast__msg').textContent = label;

    // Reiniciar barra de progreso
    var progress = toast.querySelector('.arra-undo-toast__progress');
    progress.style.transition = 'none';
    progress.style.width = '100%';
    requestAnimationFrame(function() {
      requestAnimationFrame(function() {
        progress.style.transition = 'width 5s linear';
        progress.style.width = '0%';
      });
    });

    toast.classList.add('arra-undo-toast--visible');

    // Reemplazar el botón para limpiar listeners anteriores
    var oldBtn = toast.querySelector('.arra-undo-toast__btn');
    var btn = oldBtn.cloneNode(true);
    oldBtn.parentNode.replaceChild(btn, oldBtn);

    var done = false;

    function dismiss() {
      if (done) return;
      done = true;
      toast.classList.remove('arra-undo-toast--visible');
      _arraPendingUndo = null;
    }

    function commit() {
      dismiss();
      window.location.reload();
    }

    function undo() {
      if (done) return;
      clearTimeout(_arraPendingUndo.timer);
      dismiss();
      // Si había una card oculta, restaurarla mientras recargamos
      if (card) { card.style.opacity = ''; card.style.display = ''; }
      // Re-añadir items al carrito
      var addItems = items.map(function(item) {
        var obj = { id: item.variant_id, quantity: item.quantity };
        if (item.properties && Object.keys(item.properties).length > 0) {
          obj.properties = item.properties;
        }
        return obj;
      });
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify({ items: addItems })
      }).then(function() {
        window.location.reload();
      }).catch(function() {
        window.location.reload();
      });
    }

    btn.addEventListener('click', undo);
    var timer = setTimeout(commit, 5000);
    _arraPendingUndo = { timer: timer, commit: commit };
  }

  function setupCartUndoToast() {
    var wrapper = document.querySelector('.cart-items__wrapper');
    if (!wrapper || wrapper === _undoSetupWrapper) return;
    _undoSetupWrapper = wrapper;

    wrapper.addEventListener('click', function(e) {
      var btn = e.target.closest('.cart-items__remove');
      if (!btn) return;
      var row = btn.closest('tr[data-key]');
      if (!row) return;
      var key = row.getAttribute('data-key');
      var item = null;
      for (var i = 0; i < _arraCartCache.length; i++) {
        if (_arraCartCache[i].key === key) { item = _arraCartCache[i]; break; }
      }
      if (!item) return;
      var saved = [{
        variant_id: item.variant_id,
        quantity: item.quantity,
        properties: item.properties || {}
      }];
      // Mostrar toast tras la eliminación (damos 200ms para que el tema reaccione)
      setTimeout(function() {
        showUndoToast('Artículo eliminado', saved, null);
      }, 200);
    }, false);
  }

  /* ============================
     CART: Eliminar un bundle completo
     ============================ */
  function removeBundleFromCart(keys, card) {
    // Guardar datos antes de eliminar para poder deshacer
    var savedItems = [];
    for (var i = 0; i < keys.length; i++) {
      for (var j = 0; j < _arraCartCache.length; j++) {
        if (_arraCartCache[j].key === keys[i]) {
          savedItems.push({
            variant_id: _arraCartCache[j].variant_id,
            quantity: _arraCartCache[j].quantity,
            properties: _arraCartCache[j].properties || {}
          });
          break;
        }
      }
    }

    // Ocultar la card visualmente de inmediato
    if (card) {
      card.style.transition = 'opacity 0.2s ease, transform 0.2s ease';
      card.style.opacity = '0';
      card.style.transform = 'scale(0.98)';
      setTimeout(function() { if (card) card.style.display = 'none'; }, 220);
    }

    var updates = {};
    for (var k = 0; k < keys.length; k++) {
      updates[keys[k]] = 0;
    }

    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ updates: updates })
    })
    .then(function() {
      showUndoToast('Anillo personalizado eliminado', savedItems, card);
    })
    .catch(function() {
      window.location.reload();
    });
  }

  /* ============================
     CART: Agrupar items por Bundle ID
     Muestra un encabezado "Anillo Personalizado #N"
     y marca visualmente qué charms van con qué anillo.
     ============================ */
  function groupBundleItems() {
    var table = document.querySelector('.cart-items__table tbody');
    if (!table) { startObserving(); return; }

    // Desenvolver cards padre anteriores (mover hijos al tbody y eliminar wrapper)
    var oldCards = table.querySelectorAll('.arra-bundle-card');
    for (var oc = 0; oc < oldCards.length; oc++) {
      var card = oldCards[oc];
      while (card.firstChild) {
        card.parentNode.insertBefore(card.firstChild, card);
      }
      card.remove();
    }

    // Limpiar headers de bundles anteriores
    var oldHeaders = table.querySelectorAll('.arra-bundle-header');
    for (var h = 0; h < oldHeaders.length; h++) oldHeaders[h].remove();

    // Limpiar clases de bundle anteriores
    var oldClassed = table.querySelectorAll('.arra-bundle-item, .arra-bundle-charm, .arra-bundle-item--last');
    for (var c = 0; c < oldClassed.length; c++) {
      oldClassed[c].classList.remove('arra-bundle-item', 'arra-bundle-charm', 'arra-bundle-item--last');
    }

    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        // Actualizar caché global para el undo toast
        _arraCartCache = cart.items;

        // Agrupar items por _bundle_id
        var bundles = {};
        var bundleOrder = [];

        for (var i = 0; i < cart.items.length; i++) {
          var item = cart.items[i];
          var bid = item.properties && item.properties._bundle_id;
          if (!bid) continue;

          if (!bundles[bid]) {
            bundles[bid] = {
              talla: '',
              charmParts: [],
              items: [],
              total: 0
            };
            bundleOrder.push(bid);
          }

          bundles[bid].total += item.final_line_price || item.line_price || item.price;
          var role = item.properties._bundle_role || 'item';

          // Construir descripción dinámica según lo que ESTÁ en el carrito
          if (role === 'anillo') {
            bundles[bid].talla = item.properties.Talla || '';
            bundles[bid].ringTitle = item.product_title || '';
          } else if (role === 'charm') {
            var pTitle = (item.product_title || '').toLowerCase();
            var props = item.properties || {};

            if (pTitle.indexOf('gema') !== -1) {
              var gemName = item.variant_title || props.Mes || 'gema';
              bundles[bid].charmParts.push('charm ' + gemName.toLowerCase());
            } else if (pTitle.indexOf('estampado') !== -1) {
              var forma = (props.Tipo || '').toLowerCase();
              var letra = props.Letra || '';
              var estDesc = 'charm estampado';
              if (letra) estDesc += ' "' + letra + '"';
              if (forma) estDesc += ' ' + forma;
              bundles[bid].charmParts.push(estDesc);
            } else if (pTitle.indexOf('calado') !== -1) {
              var figura = (props.Figura || '').toLowerCase();
              bundles[bid].charmParts.push('charm calado ' + figura);
            } else {
              bundles[bid].charmParts.push(item.product_title || 'charm');
            }
          }

          bundles[bid].items.push({
            key: item.key,
            role: role
          });
        }

        // Construir el nombre final de cada bundle
        // shortName = nombre dinámico visible en el header de la card
        // name      = nombre largo con charms (tooltip)
        for (var b2 = 0; b2 < bundleOrder.length; b2++) {
          var bun = bundles[bundleOrder[b2]];
          var charmCount = bun.charmParts.length;
          var charmLabel = charmCount === 1 ? '1 charm' : charmCount + ' charms';
          var ringName = bun.ringTitle || 'Anillo';
          var shortName = ringName + ' personalizado con ' + charmLabel;
          bun.shortName = shortName;

          var name = shortName;
          var parts = bun.charmParts;
          if (parts.length === 1) {
            name += ' con ' + parts[0];
          } else if (parts.length === 2) {
            name += ' con ' + parts[0] + ' y ' + parts[1];
          } else if (parts.length >= 3) {
            name += ' con ' + parts.slice(0, -1).join(', ') + ' y ' + parts[parts.length - 1];
          }
          bun.name = name;
        }

        // Si no hay bundles, reconectar y salir
        if (bundleOrder.length === 0) { startObserving(); return; }

        var rows = table.querySelectorAll('.cart-items__table-row');
        var colCount = 0;
        if (rows.length > 0) {
          colCount = rows[0].querySelectorAll('td').length;
        }

        // Para cada bundle, insertar header y marcar filas
        for (var b = 0; b < bundleOrder.length; b++) {
          var bundle = bundles[bundleOrder[b]];
          var firstRow = null;
          var lastRow = null;
          var bundleKeys = [];

          for (var j = 0; j < bundle.items.length; j++) {
            var bItem = bundle.items[j];
            var row = table.querySelector('tr[data-key="' + bItem.key + '"]');
            if (!row) continue;

            if (!firstRow) firstRow = row;
            lastRow = row;
            bundleKeys.push(bItem.key);

            row.classList.add('arra-bundle-item');
            if (bItem.role === 'charm') {
              row.classList.add('arra-bundle-charm');
            }
          }
          if (lastRow) lastRow.classList.add('arra-bundle-item--last');

          if (firstRow) {
            var bundlePrice = (bundle.total / 100).toLocaleString('es-MX', {minimumFractionDigits: 2, maximumFractionDigits: 2});
            var fullNameAttr = bundle.name.replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;');
            var headerRow = document.createElement('tr');
            headerRow.className = 'arra-bundle-header';
            headerRow.innerHTML = '<td colspan="' + colCount + '">' +
              '<div class="arra-bundle-label">' +
              '<span class="arra-bundle-name" title="' + fullNameAttr + '">' + bundle.shortName + '</span>' +
              '<button type="button" class="arra-bundle-remove" data-bundle-keys="' + bundleKeys.join(',') + '" aria-label="Eliminar ' + fullNameAttr + '">' +
              '<svg width="16" height="16" viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round">' +
              '<path d="M11.5 9v4.25M8.5 9v4.25M5.75 12.2V6h8.5c0 2.421 0 3.779 0 6.2 0 .853 0 1.447-.038 1.91-.037.453-.106.714-.207.911a2.498 2.498 0 0 1-.983 1.017c-.197.1-.458.17-.911.207-.463.037-1.057.038-1.91.038h-.4c-.853 0-1.447 0-1.91-.038-.453-.037-.714-.106-.911-.207a2.498 2.498 0 0 1-.984-1.017c-.1-.197-.17-.458-.207-.911C5.75 13.647 5.75 13.053 5.75 12.2z"/>' +
              '<path d="M4.25 6h11.5M8 5.25a2 2 0 1 1 4 0" stroke-linejoin="round"/>' +
              '</svg>' +
              '</button>' +
              '<span class="arra-bundle-price">$ ' + bundlePrice + '</span>' +
              '</div></td>';
            firstRow.parentNode.insertBefore(headerRow, firstRow);

            // Envolver header + items del bundle en una card padre
            var bundleCard = document.createElement('div');
            bundleCard.className = 'arra-bundle-card';
            bundleCard.setAttribute('data-bundle-id', bundleOrder[b]);
            firstRow.parentNode.insertBefore(bundleCard, headerRow);
            bundleCard.appendChild(headerRow);
            for (var k2 = 0; k2 < bundleKeys.length; k2++) {
              var itemRow2 = table.querySelector('tr[data-key="' + bundleKeys[k2] + '"]');
              if (itemRow2) bundleCard.appendChild(itemRow2);
            }
          }
        }

        // Attach delete handlers a los botones de bundle
        var removeBtns = table.querySelectorAll('.arra-bundle-remove');
        for (var r = 0; r < removeBtns.length; r++) {
          removeBtns[r].addEventListener('click', function(e) {
            e.preventDefault();
            var keys = this.getAttribute('data-bundle-keys').split(',');
            var card = this.closest('.arra-bundle-card');
            removeBundleFromCart(keys, card);
          });
        }

        // Reconectar observer y setup del undo toast DESPUÉS de los cambios al DOM
        setupCartUndoToast();
        setTimeout(startObserving, 100);
      })
      .catch(function() {
        startObserving();
      });
  }

  // Ejecutar al cargar la página del carrito
  stopObserving();
  rewriteCartLinks();
  groupBundleItems();

  /* Smooth parallax — ONLY on desktop
   * will-change y transform se aplican dinámicamente (no en CSS estático)
   * para que el browser pueda detectar la imagen del hero como candidato LCP
   * antes de que el loop de animación cree un nuevo stacking context. */
  var currentBgY = 0, targetBgY = 0, heroBgWillChangeSet = false;
  function lerpLoop() {
    if (nav) nav.classList.toggle('scrolled', window.scrollY > 40);
    if (!isMobile && heroBg) {
      targetBgY = window.scrollY * 0.35;
      currentBgY += (targetBgY - currentBgY) * 0.08;
      // Solo aplicar transform cuando hay movimiento real (> 0.5px)
      // Así la imagen NO tiene stacking context modificado durante la carga inicial → LCP detectable
      if (currentBgY > 0.5) {
        if (!heroBgWillChangeSet) {
          heroBg.style.willChange = 'transform'; // agregar GPU hint justo antes de animar
          heroBgWillChangeSet = true;
        }
        heroBg.style.transform = 'translate3d(0,' + currentBgY.toFixed(1) + 'px,0)';
      }
    } else if (isMobile && heroBg) {
      heroBg.style.transform = 'none';
      currentBgY = 0;
      targetBgY = 0;
    }
    requestAnimationFrame(lerpLoop);
  }
  requestAnimationFrame(lerpLoop);

  /* Scroll reveal cards — función reutilizable */
  function initCardReveal(scope) {
    var root = scope || document;
    var cards = root.querySelectorAll('.arra-card:not(.revealed)');
    if (!cards.length) return;
    if ('IntersectionObserver' in window) {
      var obs = new IntersectionObserver(function(entries) {
        for (var i = 0; i < entries.length; i++) {
          if (entries[i].isIntersecting) {
            entries[i].target.classList.add('revealed');
            obs.unobserve(entries[i].target);
          }
        }
      }, { threshold: 0.15 });
      for (var j = 0; j < cards.length; j++) { obs.observe(cards[j]); }
    } else {
      for (var k = 0; k < cards.length; k++) { cards[k].classList.add('revealed'); }
    }
  }
  initCardReveal();

  /* Re-init cuando el editor de Shopify carga/mueve una sección */
  document.addEventListener('shopify:section:load', function(e) {
    initCardReveal(e.target);
  });

});